import React, { memo, useCallback, useMemo } from 'react';

const noContentMarkup = `
  <p>No content</p>
`;

const ContentRenderer = ({ content: data }) => {
  const emptyContent = useMemo(
    () =>
      data.content === '' || typeof data.content !== 'string' || !data.content,
    [data.content]
  );

  const createMarkup = useCallback(() => {
    if (emptyContent) {
      return { __html: noContentMarkup };
    }
    return { __html: data.content };
  }, [data.content, emptyContent]);
  if (emptyContent) {
    return null;
  }
  return <div dangerouslySetInnerHTML={createMarkup()} />;
};
export default memo(ContentRenderer);
